import React from "react";
import "./DeviceTabs.scss";
import DeviceAccountTabs from "./DeviceAccountTabs";

function DeviceTabs({ selectedUser, selectedUserData, setSelectedUserData }) {
  return (
    <div className="account-tabs-container">
      <DeviceAccountTabs
        selectedUser={selectedUser}
        selectedUserData={selectedUserData}
        setSelectedUserData={setSelectedUserData}
      />
    </div>
  );
}

export default DeviceTabs;
